import { useCurrentHospital } from '@/modules/hospital';

export const useIsCommunicationEnabledOnHospital = () => {
  const {
    queryResult: { data: hospital }
  } = useCurrentHospital();
  return !!hospital?.notificationModuleEnabled;
};
